import { render, staticRenderFns } from "./SubscriptionBlock.vue?vue&type=template&id=31810fcb&scoped=true&lang=pug"
import script from "./SubscriptionBlock.vue?vue&type=script&lang=ts"
export * from "./SubscriptionBlock.vue?vue&type=script&lang=ts"
import style0 from "./SubscriptionBlock.vue?vue&type=style&index=0&id=31810fcb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31810fcb",
  null
  
)

export default component.exports